import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f0b74e92")

_pushScopeId("data-v-f0b74e92")
const _hoisted_1 = { class: "bread-crumbs" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: '/',
      class: "bread-crumbs__links"
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('menu.mainSystem')), 1 /* TEXT */)
      ]),
      _: 1
    }),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.links, (link, linkInd) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: linkInd,
        to: link.to,
        class: "bread-crumbs__links"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(link.name)), 1 /* TEXT */)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})